import { BasePostRequest } from './core/basePostRequest';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';
import { BasketItem } from 'acscp/api/models/basketItem';

export class LoyaltyOrderRequest extends BasePostRequest<undefined> {
    constructor(public items: BasketItem[]) {
        super('loyalty/order', {}, {items}, t.undefined, Authentication.Login);
    }
}
